import {
  collection,
  getDocs,
  query,
  QueryConstraint,
  where,
} from "firebase/firestore";
import { db } from "shared/api/firebase";
import { BrandType } from "../../brands/types";
import { ModuleData, ModuleStatus, ModuleType } from "../types";
import { ModuleDB } from "./Modules";

export const getActiveModuleTemplateList = async (
  brandId?: string,
  gamesOnly?: boolean,
): Promise<ModuleData[]> => {
  const collectionRef = collection(db, "moduleTemplates");
  const params: QueryConstraint[] = [
    where("status", "==", ModuleStatus.Active),
  ];

  if (brandId === BrandType.FREE) {
    params.push(
      where("type", "in", [ModuleType.Games, ModuleType.ContentBlocks]),
    );
  } else if (gamesOnly) {
    params.push(where("type", "==", ModuleType.Games));
  }

  const q = query(collectionRef, ...params);

  const querySnap = await getDocs(q);

  return querySnap.docs.map((moduleSnap) => {
    return new ModuleDB(moduleSnap).toModule();
  });
};
